<template>
  <div class="home-wrapper">

    <!-- header-bottom-start -->
    <main-nav></main-nav>
    <home-main-nav class="home-main-nav-sm"></home-main-nav>



    <!-- header-bottom-end -->

    <!-- inner-wrapper-start -->
    <div class="home-main-wrap">

        <!-- aside start -->
         <home-main-content></home-main-content>
        <!-- aside start -->

        <!-- aside start -->
        <main-sidebar-right></main-sidebar-right>
        <!-- aside end -->

    </div>
    <!-- inner-wrapper-end -->

  </div>
</template>


<script>

  export default {

  }
</script>

<style type="text/css">

  .home-main-wrap{
    display: flex;
    margin-top: 155px;
    position: relative;
  }



  @media only screen and (max-width: 1092px) {

    .home-main-wrap {
        margin-top: 110px;
    }
  }

  @media only screen and (max-width: 768px) {

    .home-main-wrap {
        margin-top: 185px;
        flex-direction: column-reverse;
    }
    .main-sidebar-right, .home-main-content {
        width: 100% !important;
        position: relative !important;
        margin: 0 auto;
        border-radius: 0px !important;
    }
    .row{
      margin: 0px !important;
    }


    .home-main-nav-sm {
      position: fixed !important;
      top: 110px;
      height: 75px;
      line-height: 75px;
      z-index: 2;
      background: #f1f2f4;
      max-width: 100% !important;
      width: 100% !important;
    }

  }

</style>